/**
 * グローバルメニューボタン
 */

export module GlobalMenuButtonModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.globalMenuButtonSetEvent();
      });
    }

    public static globalMenuButtonSetEvent() {
      const $element = document.querySelector('.mainHeader__loginBodyMenuButton');
      if ($element) {
        $element.addEventListener('click', ($event) => {
          $event.preventDefault();
          const $body = document.body;
          if ($body) {
            $body.classList.toggle('js__globalMenu--isOpen');
            return false;
          }
        });
      }
    }
  }
}